<div class="header">
    <h1>
        <div [innerHTML]="dataProcessingAddendumTitle" async | pipeSafeHTML></div>
    </h1>
    <div [innerHTML]="dataProcessingAddendumText" async | pipeSafeHTML></div>
    <div class="mt-4 w-100 d-flex justify-content-center">
        <div>
            <button class="mwp-button" (click)="download()">Download Data Processing Addendum Here</button>
        </div>
    </div>
</div>